import './Maintenance.style.scss';
import logo from 'assets/images/logo.png';
import homeImg from 'assets/images/homeImg.png';

const Maintenance = () => {
  return (
    <div className="Home">
      <img className="home_main_logo" src={logo} alt="main logo assolia" />
      <div className="home_content">
        <img className="home_logo" src={homeImg} alt="logo assolia" />
        <h1 className="title__maintenance">Maintenance en cours !</h1>
        <p>Nous serons de retour en ligne dans moins de 20 minutes.</p>
        <p className="contact-info">
          En cas de besoin, vous pouvez toujours{' '}
          <a href="mailto:contact@assolia.com">nous contacter</a>.
        </p>
        <p>— L'équipe Assolia —</p>
      </div>
    </div>
  );
};

export default Maintenance;
